import React, { Suspense, lazy } from 'react';
import { StickyAlert } from '../components/StickyAlert';
import { HeroSection } from '../components/HeroSection';
import { LazySection } from '../components/LazySection';
// Code-split chunks — JS only downloaded when section nears viewport
const StickyBonusCTA = lazy(() => import('../components/StickyBonusCTA').then(m => ({
  default: m.StickyBonusCTA
})));
const ProblemSection = lazy(() => import('../components/ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const SolutionSection = lazy(() => import('../components/SolutionSection').then(m => ({
  default: m.SolutionSection
})));
const BonusSection = lazy(() => import('../components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const ImageSlider = lazy(() => import('../components/ImageSlider').then(m => ({
  default: m.ImageSlider
})));
const PricingSection = lazy(() => import('../components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const GuaranteeSection = lazy(() => import('../components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FacebookReviews = lazy(() => import('../components/FacebookReviews').then(m => ({
  default: m.FacebookReviews
})));
const FAQSection = lazy(() => import('../components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const Footer = lazy(() => import('../components/Footer').then(m => ({
  default: m.Footer
})));
export function LandingPage() {
  return <div className="min-h-screen w-full bg-[#111111]" data-id="element-247">
      {/* ── ABOVE THE FOLD — renders immediately, no lazy ── */}
      <StickyAlert data-id="element-248" />
      <HeroSection data-id="element-249" />

      {/* StickyBonusCTA: fixed overlay, no height impact */}
      <Suspense fallback={null} data-id="element-250">
        <StickyBonusCTA data-id="element-251" />
      </Suspense>

      {/* ── BELOW THE FOLD — viewport-gated rendering + code splitting ── */}
      {/* Each LazySection holds the placeholder until 900px before viewport,
            then swaps in the real component. CLS = 0 because placeholder
            reserves the estimated height. bg colors match section backgrounds. */}

      <LazySection estimatedHeight={600} placeholderBg="#1C1C1C" data-id="element-252">
        <Suspense fallback={<div style={{
        minHeight: 600,
        backgroundColor: '#1C1C1C'
      }} data-id="element-254" />} data-id="element-253">
          <ProblemSection data-id="element-255" />
        </Suspense>
      </LazySection>

      <LazySection estimatedHeight={1400} placeholderBg="#0a0a0a" data-id="element-256">
        <Suspense fallback={<div style={{
        minHeight: 1400,
        backgroundColor: '#0a0a0a'
      }} data-id="element-258" />} data-id="element-257">
          <SolutionSection data-id="element-259" />
        </Suspense>
      </LazySection>

      <LazySection estimatedHeight={2200} placeholderBg="#0a0a0a" data-id="element-260">
        <Suspense fallback={<div style={{
        minHeight: 2200,
        backgroundColor: '#0a0a0a'
      }} data-id="element-262" />} data-id="element-261">
          <BonusSection data-id="element-263" />
        </Suspense>
      </LazySection>

      <LazySection estimatedHeight={700} placeholderBg="#1C1C1C" data-id="element-264">
        <Suspense fallback={<div style={{
        minHeight: 700,
        backgroundColor: '#1C1C1C'
      }} data-id="element-266" />} data-id="element-265">
          <ImageSlider data-id="element-267" />
        </Suspense>
      </LazySection>

      <LazySection estimatedHeight={1000} placeholderBg="#1C1C1C" data-id="element-268">
        <Suspense fallback={<div style={{
        minHeight: 1000,
        backgroundColor: '#1C1C1C'
      }} data-id="element-270" />} data-id="element-269">
          <PricingSection data-id="element-271" />
        </Suspense>
      </LazySection>

      <LazySection estimatedHeight={700} placeholderBg="#0a0a0a" data-id="element-272">
        <Suspense fallback={<div style={{
        minHeight: 700,
        backgroundColor: '#0a0a0a'
      }} data-id="element-274" />} data-id="element-273">
          <GuaranteeSection data-id="element-275" />
        </Suspense>
      </LazySection>

      <LazySection estimatedHeight={1200} placeholderBg="#1C1C1C" data-id="element-276">
        <Suspense fallback={<div style={{
        minHeight: 1200,
        backgroundColor: '#1C1C1C'
      }} data-id="element-278" />} data-id="element-277">
          <FacebookReviews data-id="element-279" />
        </Suspense>
      </LazySection>

      <LazySection estimatedHeight={900} placeholderBg="#1C1C1C" data-id="element-280">
        <Suspense fallback={<div style={{
        minHeight: 900,
        backgroundColor: '#1C1C1C'
      }} data-id="element-282" />} data-id="element-281">
          <FAQSection data-id="element-283" />
        </Suspense>
      </LazySection>

      <LazySection estimatedHeight={400} placeholderBg="#0a0a0a" data-id="element-284">
        <Suspense fallback={<div style={{
        minHeight: 400,
        backgroundColor: '#0a0a0a'
      }} data-id="element-286" />} data-id="element-285">
          <Footer data-id="element-287" />
        </Suspense>
      </LazySection>
    </div>;
}